import { gql } from "urql";

export const LOGIN: any = gql(`
    mutation Login($loginUserInput: LoginUserInput!) {
        login(loginUserInput: $loginUserInput) {
            user {
                _id
                name
            }
            authToken
        }
    }
`)

export const SEND_EMAIL_RESET_PASSWORD: any = gql(`
    mutation SendEmailResetPassword {
        SendEmailResetPassword 
    }
`)

export const SEND_EMAIL_RESET_PASSWORD_BY_EMAIL: any = gql(`
    mutation SendEmailResetPasswordByEmail($email: String!) {
        SendEmailResetPasswordByEmail(email: $email) 
    }
`)

export const RESET_PASSWORD: any = gql(`
    mutation ResetPassword($newPassword: String!, $token: String!) {
        ResetPassword(newPassword: $newPassword, token: $token)
    }
`)

export const MUTATION_GET_OAUTH_TOKEN: any = gql(`
    mutation GetOAuthToken($userId: String) {
        getOAuthToken(userId: $userId)
    }
`)

export const MUTATION_EXCHANGE_OAUTH_TOKEN: any = gql(`
    mutation ExchangeOAuthToken($token: String!) {
        exchangeOAuthToken(token: $token)
    }
`)